import { ZustandBonusPackStore } from './types';

export const isAvailableBonusPackSelector = (state: ZustandBonusPackStore) =>
  state.isAvailable;

// =========================== Action ===========================

export const setBalanceInfoAction = (state: ZustandBonusPackStore) =>
  state.setIsAvailableStatus;
